import React, { useState, useEffect } from "react";

import MUIDataTable from "mui-datatables";

const baseColumns = [
  "application",
  "event",
  "pageURL",
  "pageTitle",
  "orgPrefix",
  "teamType",
  "accountID",
  "projectID",
  "tanID",
  "onsiteVipTestId",
  "professionName",
  "strengthName",
  "roleName",
  "competenceName",
  "aptitudeName",
  "championID",
  "championName",
  "championProfileURL",
  "videoIndex",
  "videoTitle",
  "videoURL",
  "clickTarget",
  "clickURL",
  "slideViewIndex",
  "slideTitle",
  "workshopType",
  "workshopPersons",
  "workshopDate",
  "workshopLanguage",
  "timeSpent",
  "professionName",
  "strengthName",
  "roleName",
  "competenceName",
  "aptitudeName",
  "communicationPreference",
  "newsletterEmail",
  "downloadTarget",
  "downloadURL",
  "downloadFileType",
];

const Table = ({ title, columns, data, options }) => {
  const [updatedColumns, setUpdatedColumns] = useState([]);
  const [parsedData, setParsedData] = useState([]);

  useEffect(() => {
    const parsedColumns = [...baseColumns].filter((column) => columns.includes(column));
    setUpdatedColumns(parsedColumns);

    const parsedDataRows = [];
    data.forEach(({ count, _id: stats }) => {
      const parsedData = parsedColumns.map((column) => {
        return stats[column];
      });
      parsedData.push(count);
      parsedDataRows.push(parsedData);
    });
    setParsedData(parsedDataRows);
  }, [columns, data]);

  return (
    <MUIDataTable
      title={title}
      columns={[...updatedColumns, "count"]}
      data={parsedData}
      options={{
        ...options,
        selectableRows: "none",
        filterType: "multiselect",
        onDownload: (buildHead, buildBody, columns, data) => {
          const undefinedIndexes = [];
          let parsedColumns = columns.filter((column, index) => {
            const validValue = data.some((row) => row?.data?.[index]);

            if (!validValue) undefinedIndexes.push(index);

            return validValue;
          });

          let parsedData = data.map(({ data: rowData }) => {
            const filteredData = rowData.filter((value, index) => {
              return !undefinedIndexes.includes(index);
            });

            return { index: undefined, data: filteredData };
          });

          return buildHead(parsedColumns) + buildBody(parsedData);
        },
        downloadOptions: {
          filterOptions: {
            useDisplayedColumnsOnly: true,
            useDisplayedRowsOnly: true,
          },
        },
      }}
    />
  );
};

export default Table;
